import React from "react";
import { useState ,useRef} from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/OSBYOSLogo.jpg";
import TitlebarImageList from "./HomeImages.js";
import { styled } from "@mui/system";
import Button from '@mui/material/Button';
import Stack from "@mui/material/Stack";
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import IconButton from '@mui/material/IconButton';
import HeroVideo from './HeroVideo.js'
import LandingPage from "./LandingPage.js";
// import Particle from "./Particle";

const black = {
  500: "#010203",
  600: "#121212",
  700: "#232323",
};

const CustomButton = styled(Button)`
  font-family: Melbourne, sans-serif;
  font-weight: bold;
  font-size: 0.875rem;
  background-color: ${black[500]};
  padding: 12px 24px;
  border-radius: 12px;
  color: white;
  transition: all 150ms ease;
  cursor: pointer;
  border: none;
  text-transform: none; /* optional: prevents uppercase text */

  &:hover {
    background-color: ${black[600]};
  }

  &:active {
    background-color: ${black[700]};
  }

  &:focus-visible {
    box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1),
      0 0 0 5px rgba(0, 127, 255, 0.5);
    outline: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;


function Home() {
  const navigate = useNavigate();
  const AboutUs = () => {
    navigate("/AboutUs", {});
  };

    const osss25 = () => {
    navigate("/Collection", { state: { type: "osss25", row: 3 } })
  };

   const os24 = () => {
    navigate("/Collection", { state: { type: "os24", row: 3 } })
  };

  return (
    <React.Fragment>
  <LandingPage></LandingPage>
  <div className="HeroSection">
  <div className="side-image-wrapper" onClick={os24} style={{ position: 'relative'}}>
  <img
    src="https://d3lwdqji776yyc.cloudfront.net/HomeImages/OS-BY-OS-25-SEPTEMBER-20244356-1-1.webp"
    alt="Left"
    className="side-image"
  />
  <div className="hide-title-from-side-images"
   style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      padding: '12px 20px',
      background: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(4px)',
      color: 'white',
      fontSize: '1.5rem',
      fontFamily: "'Melbourne', serif", // Use your custom font
      textShadow: '1px 1px 4px rgba(0,0,0,0.8)',
      boxSizing: 'border-box',
    }}
  >
    OS 24 Collection
  </div>
  </div>
  {/* <HeroVideo/> */}
  <div className="side-image-wrapper" onClick={osss25} style={{ position: 'relative'}}>
  <img
    src="https://d3lwdqji776yyc.cloudfront.net/HomeImages/CNA05716-copy-2-1.webp"
    alt="Right"
    className="side-image"
  />
  <div className="hide-title-from-side-images"
   style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      padding: '12px 20px',
      background: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(4px)',
      color: 'white',
      fontSize: '1.5rem',
      fontFamily: "'Melbourne', serif", // Use your custom font
      textShadow: '1px 1px 4px rgba(0,0,0,0.8)',
      boxSizing: 'border-box',
    }}
  >
    OS 25 Collection
  </div>
  </div>
 </div>
      <div className="AboutDiv">
        <div className="AboutPara">
          <p>
            OSBYOS is a bespoke tailoring brand that upholds the finest
            tailoring traditions, following some of the best practices around
            the world in custom menswear. After having worked with some of the
            biggest names in bespoke menswear like Tom Ford and Ermenegildo
            Zegna for over a decade, the founder, Owais Shaikh – also the winner
            of GQ magazine’s best dressed men award in 2015 – decided to use his
            experience to foster his own vision through OSBYOS.
            <br></br>
            <br></br>
          </p>
        </div>
      </div>
      <div className="KnowMore">
        <Stack spacing={2} direction="row">
          <CustomButton onClick={AboutUs}>KNOW MORE</CustomButton>
        </Stack>
      </div>
      <TitlebarImageList></TitlebarImageList>
    </React.Fragment>
  );
}

export default Home;
